import { connect } from 'react-redux';
import * as routes from 'app/routes';

import ConfirmInsurance from 'insurance/ConfirmInsurance/sprint';
import InsuranceConfirm from './InsuranceConfirm';

const mapStateToProps = (state) => ({
  ConfirmInsurance,
  insurancePlanRoute: routes.sprintInsurancePlan
});

export default connect(
  mapStateToProps,
  null
)(InsuranceConfirm);
